import { valueFormat } from "src/helper/valueFormat";

export const convertTips = (tipInfo, orderData) => {
  if (tipInfo?.kitchen && tipInfo?.driver) {
    const staffTip = Number(orderData?.charges?.tipInfo?.kitchen).toFixed(2);
    const driverTip = Number(orderData?.charges?.tipInfo?.driver).toFixed(2);
    const tips = Number(staffTip) + Number(driverTip);
    const fixedTip = Number(tips).toFixed(2);
    return valueFormat(`$${fixedTip}`);
  } else if (tipInfo?.kitchen && !tipInfo?.driver) {
    const staffTip = Number(orderData?.charges?.tipInfo?.kitchen).toFixed(2);
    const tips = Number(staffTip).toFixed(2);
    return valueFormat(`$${tips}`);
  } else if (!tipInfo?.kitchen && tipInfo?.driver) {
    const driverTip = Number(orderData?.charges?.tipInfo?.driver).toFixed(2);
    return valueFormat(`$${driverTip}`);
  }
};

export const convertTaxAndFee = (fee, tax) => {
  return valueFormat(
    `$${Number(
      fee?.processingFee + fee?.marketplaceFee + fee?.ordersCoFee + tax
    ).toFixed(2)}`
  );
};

export const convertStaffTip = (staffTip) => {
  return valueFormat(`$${Number(staffTip).toFixed(2)}`);
};
